import { render, staticRenderFns } from "./EdicaoResultado.vue?vue&type=template&id=4688bcf8&"
import script from "./EdicaoResultado.vue?vue&type=script&lang=js&"
export * from "./EdicaoResultado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports